import client from '../../client';

const MANDATES = {
  getMandate(mandateId) {
    return client.get(`/sellers/${client.customerId()}/mandates/${mandateId}`);
  },

  updateMandate(mandateId, params) {
    return client.put(`/sellers/${client.customerId()}/mandates/${mandateId}`, { mandate: params });
  },
 
  genereteMandate(mandateId) {
    return client.post(`/sellers/${client.customerId()}/mandates/${mandateId}/e_signs`);
  },
};

export default MANDATES;
